import React, { Component } from "react"

/* Components */
import { Layout, Video } from "../components"

/* REST API */
import { video } from "../api/Dashboard"



/* Widget Video */
class History extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: []
        }
    }

    /* Load Action */
    load = (reload = false) => {

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Token */
        const { token } = this.props

        /* Check token */
        if (!token) return

        /* Send to REST API */
        video({ token }).then(response => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })
    }

    render = () => {

        /* Fields */
        const { status, data } = this.state
        const { open } = this.props

        /* Draw Layout */
        if (status !== "ok") {
            return (
                <div className="stream-history">
                    <Layout status={status} reload={() => this.load(true)} mode="light" />
                </div>
            )
        }

        return (
            <div className="stream-history">
                {data.map((item, index) =>
                    <div className="stream-history-container" key={`${index}`}>
                        <div className="stream-history-title">{item.title}</div>
                        <div className="stream-history-video">
                            {item.video.map((_video, _index) => <Video data={_video} key={`${index}-${_video.id}`} open={() => open(_video)} />)}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default History